/**
 * @file
 * Breadcrumb module to update query params
 */

import queryString from "query-string";

const hasWindowLocation = window && window.location;
const hasHistoryReplaceState = window && window.history && window.history.replaceState;

const Breadcrumb = {
	/**
	 * Update query param based on the passed in key and value
	 *
	 * @param {object} param - The key and value pair for the query
	 * @param {string} param.key - The query key
	 * @param {string} param.value - The corresponding query value
	 */
	set({
		key,
		value,
	} = {}) {
		if (hasWindowLocation && hasHistoryReplaceState && key) {
			const query = {
				...queryString.parse(window.location.search),
				[key]: value,
			};

			window.history.replaceState(null, null, `?${queryString.stringify(query)}`);
		}
	},

	/**
	 * Remove the given query key
	 * If there are no query params to begin with or
	 * if there will be no query params left once the passed in query key is removed
	 * replace state to just the path name
	 *
	 * @param {string} key - The query key to be deleted from the query param
	 */
	reset(key) {
		if (hasWindowLocation && hasHistoryReplaceState) {
			const query = { ...queryString.parse(window.location.search) };
			const queryKeyLength = Object.keys(query).length;

			if (queryKeyLength === 0 || (queryKeyLength === 1 && query[key])) {
				window.history.replaceState(null, null, window.location.pathname);
			} else {
				delete query[key];

				window.history.replaceState(null, null, `?${queryString.stringify(query)}`);
			}
		}
	},
};

export default Breadcrumb;



// WEBPACK FOOTER //
// ./src/shared/util/Breadcrumb.js